import React, { useEffect } from "react";
import useTranslation from "next-translate/useTranslation";
import styles from "./styles/Ads.module.css";
import Link from "next/link";
import { REGULAR_TIER, UNLIMITED_TIER } from "@chesshotel/constants";
import { useMembership } from "../redux/membership";
import { useUser } from "../redux/user";
import { useSiteData } from "../redux/siteData";

function pushAdTags(tier) {
  if (tier !== REGULAR_TIER && tier !== UNLIMITED_TIER) {
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (err) {
      // console.log(err);
    }
  }
}

export default function AdSense({
  showRemoveAds,
  insStyle,
  slot,
  adStyles,
  contStyles = null,
  format,
}) {
  const { t } = useTranslation("common");
  const { tier } = useMembership();
  const { isGuest } = useUser();
  const { adsVisible } = useSiteData();

  useEffect(() => {
    if (adsVisible) {
      pushAdTags(tier);
    }
  }, [adsVisible]);

  if (tier === REGULAR_TIER || tier === UNLIMITED_TIER) {
    return null;
  }

  return (
    <div className={`${styles.cont} ${contStyles ? contStyles : ""}`}>
      <div className={adStyles}>
        <ins
          className="adsbygoogle"
          style={insStyle}
          data-ad-client="ca-pub-3075327144693930"
          data-ad-slot={slot}
          data-ad-format={format}
          data-full-width-responsive={"true"}
        ></ins>
      </div>
      {showRemoveAds && !isGuest ? (
        <div className={styles.removeAds}>
          <Link href={"/memberships"}>{t("Remove ads?")}</Link>
        </div>
      ) : (
        <div className={styles.removeAds}></div>
      )}
    </div>
  );
}
